<template>
  <section class="">
    <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12 p-col-12">
    <DataTable
    :value="salesBillSundaryLists"
      :paginator="true"
      :rows="10" :filters="filters"
      class="p-datatable-responsive p-datatable-gridlines"
      data-key="id"
      >
      <Column header="S.N">
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
      <Column header="Name" field="expensesName" filterMatchMode="contains" :sortable="true" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['expensesName']" />
        </template>
      </Column>
      <Column header="Apply Vat"  >
        <template #body="slotProps">
          {{slotProps.data.applyVat?'Yes':'No'}}
        </template>
      </Column>
     <Column header="Debit Account" field="debitAccountName" filterMatchMode="contains" :sortable="true"  >
     <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['debitAccountName']" />
        </template>
      </Column>
     <Column header="Credit Account" field="creditAccountName" filterMatchMode="contains" :sortable="true" >
     <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['creditAccountName']" />
        </template>
      </Column>
        <template #empty>No record found</template>
     <Column header="Action" >
       <template #body="slotProps">
        <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editBillSundary(slotProps.data)"/>
        <Button icon="pi pi-trash" class="p-button-raised p-button-danger" v-if="!slotProps.data.systemOnly"
         @click="openDialog(slotProps.data.id)" />
        <Button icon="pi pi-trash" class="p-button-raised p-button-danger" v-else @click="openDialog(slotProps.data.id)" disabled/>
      </template>
      </Column>
    </DataTable>
    </div>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deletePurchaseSundary"/>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
export default {
  name: 'salesBillSundaryList',
  data() {
    return {
      dialogShow: false,
      accountId: '',
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  },
  computed: {
    salesBillSundaryLists() {
      return this.$store.state.billSundary.billSundaryLists
    }
  },
  mounted() {
    this.salesBillSundaryList()
  },
  methods: {
    async salesBillSundaryList() {
      await this.$store.dispatch('loadSalesBillSundry')
    },
    async deletePurchaseSundary(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete reason cannot be empty.',
          messageType: 'error'
        }
        this.dialogShow = true
        this.$emit('delete-message', message)
        return
      }
      let deleteRe = {
        inventoryExpensesId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deletePurchaseSundary', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
        this.closeDialog()
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
    },
    editBillSundary(data) {
      this.$emit('edit-account', data)
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    }
  }
}
</script>

<style>
.p-datatable table {
    border-collapse: collapse;
    width: 100%;
    table-layout: auto;
    column-gap: inherit;
}
</style>



// WEBPACK FOOTER //
// salesExtraExpensesList.vue?09b23a26